import { Reveal } from '@/components/ui/Reveal';
import { MapPin } from '@/components/ui/Icons';
import { company } from '@/data/company';

export function AreasServed() {
  return (
    <section className="bg-paper-0">
      <div className="container-page py-16 sm:py-20">
        <Reveal className="mx-auto max-w-3xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-gold-700">Areas covered</p>
          <h2 className="mt-3 font-display text-3xl font-semibold leading-tight text-navy-900 sm:text-4xl/10">
            Trusted local contractors across {company.areasServed.join(', ')}
          </h2>
          <p className="mt-4 text-ink-700">
            We work right across our hub county and the surrounding areas. If your town
            isn’t listed below, give us a call and we’ll let you know.
          </p>
        </Reveal>

        <ul className="mx-auto mt-10 flex max-w-4xl flex-wrap items-center justify-center gap-2.5">
          {company.serviceTowns.map((town, i) => (
            <Reveal key={town} delay={0.03 * i}>
              <li>
                <span className="inline-flex items-center gap-2 rounded-full border border-paper-100 bg-paper-50 px-4 py-2 text-sm font-medium text-navy-800 transition hover:-translate-y-0.5 hover:border-gold-400 hover:text-gold-700">
                  <MapPin className="h-3 w-3 text-gold-500" />
                  {town}
                </span>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}
